import { ParkingIcon } from './ParkingIcon';

/**
 * author: Google
 * id 07C8266A-A135-443C-B2DD-4148CD718C51
 * name parking
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/parking.svg
 * tags
 * - Places 
 */
export const LocalParkingIcon = ParkingIcon;
export default LocalParkingIcon